/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import NftControllerDtoNftGenerateCreateRequest from '../model/NftControllerDtoNftGenerateCreateRequest';
import NftControllerDtoNftGenerateDetailRequest from '../model/NftControllerDtoNftGenerateDetailRequest';
import NftControllerDtoNftGenerateDetailResponse from '../model/NftControllerDtoNftGenerateDetailResponse';
import NftControllerDtoNftGenerateItemCreateRequest from '../model/NftControllerDtoNftGenerateItemCreateRequest';
import NftControllerDtoNftGenerateItemListRequest from '../model/NftControllerDtoNftGenerateItemListRequest';
import NftControllerDtoNftGenerateItemListResponse from '../model/NftControllerDtoNftGenerateItemListResponse';
import NftControllerDtoNftGenerateItemRemoveRequest from '../model/NftControllerDtoNftGenerateItemRemoveRequest';
import NftControllerDtoNftGenerateListRequest from '../model/NftControllerDtoNftGenerateListRequest';
import NftControllerDtoNftGenerateListResponse from '../model/NftControllerDtoNftGenerateListResponse';
import NftControllerDtoNftGenerateRemoveRequest from '../model/NftControllerDtoNftGenerateRemoveRequest';
import NftControllerDtoNftGenerateStartCreatingRequest from '../model/NftControllerDtoNftGenerateStartCreatingRequest';

/**
* PerplayNft service.
* @module api/PerplayNftApi
* @version 1.0
*/
export default class PerplayNftApi {

    /**
    * Constructs a new PerplayNftApi. 
    * @alias module:api/PerplayNftApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayNftNftGenerateCreatePost operation.
     * @callback module:api/PerplayNftApi~apiPerplayNftNftGenerateCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftControllerDtoNftGenerateCreateRequest} [nftControllerDtoNftGenerateCreateRequest] 
     * @param {module:api/PerplayNftApi~apiPerplayNftNftGenerateCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayNftNftGenerateCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftControllerDtoNftGenerateCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayNft/NftGenerateCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayNftNftGenerateDetailPost operation.
     * @callback module:api/PerplayNftApi~apiPerplayNftNftGenerateDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NftControllerDtoNftGenerateDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftControllerDtoNftGenerateDetailRequest} [nftControllerDtoNftGenerateDetailRequest] 
     * @param {module:api/PerplayNftApi~apiPerplayNftNftGenerateDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NftControllerDtoNftGenerateDetailResponse}
     */
    apiPerplayNftNftGenerateDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftControllerDtoNftGenerateDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = NftControllerDtoNftGenerateDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayNft/NftGenerateDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayNftNftGenerateItemCreatePost operation.
     * @callback module:api/PerplayNftApi~apiPerplayNftNftGenerateItemCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftControllerDtoNftGenerateItemCreateRequest} [nftControllerDtoNftGenerateItemCreateRequest] 
     * @param {module:api/PerplayNftApi~apiPerplayNftNftGenerateItemCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayNftNftGenerateItemCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftControllerDtoNftGenerateItemCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayNft/NftGenerateItemCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayNftNftGenerateItemListPost operation.
     * @callback module:api/PerplayNftApi~apiPerplayNftNftGenerateItemListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NftControllerDtoNftGenerateItemListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftControllerDtoNftGenerateItemListRequest} [nftControllerDtoNftGenerateItemListRequest] 
     * @param {module:api/PerplayNftApi~apiPerplayNftNftGenerateItemListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NftControllerDtoNftGenerateItemListResponse}
     */
    apiPerplayNftNftGenerateItemListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftControllerDtoNftGenerateItemListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = NftControllerDtoNftGenerateItemListResponse;
      return this.apiClient.callApi(
        '/api/PerplayNft/NftGenerateItemList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayNftNftGenerateItemRemovePost operation.
     * @callback module:api/PerplayNftApi~apiPerplayNftNftGenerateItemRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftControllerDtoNftGenerateItemRemoveRequest} [nftControllerDtoNftGenerateItemRemoveRequest] 
     * @param {module:api/PerplayNftApi~apiPerplayNftNftGenerateItemRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayNftNftGenerateItemRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftControllerDtoNftGenerateItemRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayNft/NftGenerateItemRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayNftNftGenerateListPost operation.
     * @callback module:api/PerplayNftApi~apiPerplayNftNftGenerateListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NftControllerDtoNftGenerateListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftControllerDtoNftGenerateListRequest} [nftControllerDtoNftGenerateListRequest] 
     * @param {module:api/PerplayNftApi~apiPerplayNftNftGenerateListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NftControllerDtoNftGenerateListResponse}
     */
    apiPerplayNftNftGenerateListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftControllerDtoNftGenerateListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = NftControllerDtoNftGenerateListResponse;
      return this.apiClient.callApi(
        '/api/PerplayNft/NftGenerateList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayNftNftGenerateRemovePost operation.
     * @callback module:api/PerplayNftApi~apiPerplayNftNftGenerateRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftControllerDtoNftGenerateRemoveRequest} [nftControllerDtoNftGenerateRemoveRequest] 
     * @param {module:api/PerplayNftApi~apiPerplayNftNftGenerateRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayNftNftGenerateRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftControllerDtoNftGenerateRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayNft/NftGenerateRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayNftNftGenerateSealListPost operation.
     * @callback module:api/PerplayNftApi~apiPerplayNftNftGenerateSealListPostCallback
     * @param {String} error Error message, if any.
     * @param {Array.<String>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/PerplayNftApi~apiPerplayNftNftGenerateSealListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<String>}
     */
    apiPerplayNftNftGenerateSealListPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ['String'];
      return this.apiClient.callApi(
        '/api/PerplayNft/NftGenerateSealList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayNftNftGenerateStartCreatingPost operation.
     * @callback module:api/PerplayNftApi~apiPerplayNftNftGenerateStartCreatingPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftControllerDtoNftGenerateStartCreatingRequest} [nftControllerDtoNftGenerateStartCreatingRequest] 
     * @param {module:api/PerplayNftApi~apiPerplayNftNftGenerateStartCreatingPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayNftNftGenerateStartCreatingPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftControllerDtoNftGenerateStartCreatingRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayNft/NftGenerateStartCreating', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
